/* eslint-disable no-unused-vars */
<template>
  <v-card
    class="mx-auto categories-card"
    flat
  >
    <v-toolbar short flat>
      <v-toolbar-title>
        <v-icon class="toolbar-icon">{{ lang.categories.icon }}</v-icon>
        {{ `${lang.categories.title_} ${lang[catalog].title}` }}
      </v-toolbar-title>
    </v-toolbar>
    <v-skeleton-loader
      v-if="!socketInfo.firstLoad"
      type="list-item@5"
    ></v-skeleton-loader>
    <v-draggable-treeview
      v-else
      v-model="categories"
    >
      <template v-slot:label="{ item }">
        <v-list>
          <div
            :class="{
              'list-cat-label': true,
              'inactive-cat': !(item.active),
              'selected': (saveCat.id === item.id)
            }"
          >
            <span>{{ item.name }}</span>
          </div>
        </v-list>
      </template>
      <template v-slot:append="{ item }">
        <v-expand-transition>
          <Form
            v-if="saveCat.id > 0 && saveCat.id === item.id"
            :cat="saveCat"
            :catalog="catalog"
            @closed="closeSaveCat"
          />
          <template v-else>
            <Actions :catalog="catalog" :category="item" @edit="editCat"/>
          </template>
        </v-expand-transition>
      </template>
    </v-draggable-treeview>
      <div v-if="permissions.catalog.categories.actions.new">
        <v-list>
          <v-expand-transition>
            <v-list-item
              v-if="!newCatForm"
              link
              @click="newCat()"
              class="new-cat"
            >
                <v-list-item-icon>
                  <v-icon>mdi-plus-thick</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ lang.items.categories.add }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <Form
              v-else
              :catalog="catalog"
              @closed="closeSaveCat"
            />
          </v-expand-transition>
        </v-list>
      </div>
  </v-card>
</template>

<script>
import Actions from './templates/Actions'
import Form from './templates/Form'

import defaults from '@/modules/default'
import appdata from '@/mixins/appdata'

export default {
  components: { Actions, Form },
  mixins: [ appdata ],
  props: {
    catalog: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      newCatForm: false,
      saveCat: { ...defaults.blank.category(this.catalog) },
      timeOut: {}
    }
  },

  computed: {
    categories: {
      get: function () {
        const categories = Object.values(this.get_data.categories) || []
        const catalogCats = categories.filter(cat => cat.catalog === this.catalog) || []
        var parents = catalogCats.filter(cat => cat.parent === 0) || []
        parents.forEach(function (val) {
          const childrens = catalogCats.filter(cat => cat.parent === val.id) || []
          val.children = (childrens.length > 0 ? childrens : [])
        })
        return parents
      },
      set: function (newValue) {
        const categories = Object.assign({}, newValue) || {}
        var sortedCats = []
        Object.entries(categories).forEach(function ([key, value]) {
          value.sortable = (parseInt(key) + 1)
          Object.entries(value.children).forEach(function ([childKey, childValue]) {
            childValue.sortable = (parseInt(childKey) + 1)
            delete childValue.children
            sortedCats.push(childValue)
          })
          delete value.children
          sortedCats.push(value)
        })
        // eslint-disable-next-line no-unused-vars
        this.get_data.categories = Object.assign({ ...Object.entries(this.get_data.categories).filter(([key, cat]) => cat.catalog !== this.catalog) }, sortedCats)
        clearTimeout(this.timeOut)
        this.timeOut = setTimeout(function () {
          this.$store.dispatch('saveMixed', { page: 3, type: 4, data: { catalog: this.catalog, sorted: sortedCats }, ignoreResponseBar: false })
        }.bind(this), 2500)
      }
    }
  },

  methods: {
    newCat () {
      this.saveCat = { ...defaults.blank.category(this.catalog) }
      this.newCatForm = true
    },
    editCat (cat) {
      this.newCatForm = false
      this.saveCat = Object.assign({}, cat)
      this.saveCat.children = {}
    },
    closeSaveCat () {
      this.newCatForm = false
      this.saveCat = { ...defaults.blank.category(this.catalog) }
    }
  }
}
</script>

<style src="./styles/categories.scss" lang="scss"></style>
